import gsap from 'gsap'
import React, {useEffect, useRef} from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {makeEditable, tailwindConfig, unwrapAllNodeResolvers} from '@/common/utils'

const KeyFiguresItem = ({leading, number, trailing, increment, content, _editable}) => {
  const sectionRef = useRef()
  const numberRef = useRef()

  useEffect(() => {
    const mm = gsap.matchMedia()
    mm.add(`(min-width: ${tailwindConfig.theme.screens['lg']})`, () => {
      gsap.fromTo(
        numberRef.current,
        {innerText: 0},
        {
          scrollTrigger: {
            trigger: sectionRef.current,
          },
          innerText: number,
          duration: 1,
          snap: {
            innerText: increment,
          },
        }
      )
    })

    return () => mm.revert()
  }, [number, increment])

  if (!number) return null

  return (
    <li
      {...makeEditable(_editable)}
      className='relative flex h-full w-full flex-col flex-wrap gap-2'
      ref={sectionRef}
    >
      {(leading || number || trailing) && (
        <p className='misc-figures whitespace-nowrap text-[55px] text-transparent [-webkit-text-stroke:theme(colors.yellow.400)_2px] md:text-[5.25rem]'>
          {leading}
          <span ref={numberRef}>{number}</span>
          {trailing}
        </p>
      )}
      <span className='heading-xs-millik text-white'>
        {render(content, {nodeResolvers: unwrapAllNodeResolvers})}
      </span>
    </li>
  )
}

export default KeyFiguresItem
